import React from "react";
import Serve from "../components/serve";
import NavbarComponent from "../components/navbar/Navbar";
import Hero from "../components/hero/";
import Services from "../components/services";
import Process from "../components/process";
import Testimonial from "../components/testimonial";
import Footer from "../components/footer";
import AIServices from "components/aiServices/AIServices";
import WhyUs from "components/whyUs/WhyUs";
import OpenRoles from "components/hiring/OpenRoles";
import usePageMeta from "components/seo/usePageMeta";

const HomePage = () => {
  usePageMeta({
    description:
      "Dobedo Soft is an AI-first software studio. We design and build AI agents, LLM and RAG solutions, web and mobile apps, and SaaS products for startups and businesses worldwide.",
    path: "/",
  });

  return (
    <>
      <NavbarComponent />
      <Hero />

      <div>
        <Services />
      </div>

      <div className="m-100">
        <AIServices />
      </div>

      <Serve />

      <div className="m-100">
        <Process />
      </div>

      <WhyUs />

      <Testimonial />

      <OpenRoles />

      <Footer />
    </>
  );
};

export default HomePage;
